<template>
    <el-card style="height: calc(100vh - 140px);display: flex;flex-direction: column" shadow="never"
             class="batch-create-meeting">
        <div slot="header">
            <div class="float-left">
                <one-file-upload
                    :upload-url="modelImportUrl"
                    :extensions="['xls','xlsx']"
                    :accept="['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel']"
                    @start="handleBeforeUpload"
                    @success="handleUploadSuccess"
                >
                    <el-button size="medium" type="success" class="mr-2"
                               icon="el-icon-upload2">{{('导入Excel')}}
                    </el-button>
                </one-file-upload>
            </div>
            <el-button size="medium" @click="goDownload" type="danger"
                       icon="el-icon-download">{{('下载样本')}}
            </el-button>
            <el-button size="medium" @click="goReport" type="info" class="ml-5"
                       icon="el-icon-document">下载结果
            </el-button>
            <div class="pull-right text-info">批量创建会议，请先准备好Excel，导入excel即可开始创建会议.</div>
        </div>
        <div class="mt-3 h-100" style="overflow-x: hidden;overflow-y: auto" ref="live_view">
            <table style="width: 100%" ref="excel_table">
                <tbody>
                <tr class="" v-for="(le,index) in result" :key="index">
                    <td v-for="(x,i) in le.data" :key="'td'+i">
                        {{x}}
                    </td>
                    <td v-if="!le.success" class="text-danger">{{le.message}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </el-card>

</template>

<script>

    import CommonMixin from "@/common/mixins/common-mixin";
    import OneFileUpload from "../components/common-file-upload";
    import XLSX from "xlsx";
    import FileSaver from "file-saver";
    import SseMixin from "@/common/mixins/sse-mixin";

    export default {
        name: "profile",
        components: {OneFileUpload},
        mixins: [CommonMixin,SseMixin],
        data() {
            return {
                model:'ZoomBook',
                live: false,
                result:[],
            }
        },
        computed: {
            modelImportUrl() {
                return this.$apiUrl("Admin.Meeting.Import");
            },
        },
        methods: {
            goDownload() {
                window.open('/assets/files/视频会议批量创建模板.xlsx');
            },
            handleBeforeUpload(){
                this.result = [];
            },
            goReport() {
                this.exportExcel('建会结果');
            },
            // 导出表格
            exportExcel(name) {
                /* generate workbook object from table */
                let opt = {raw:true};
                let wb = XLSX.utils.table_to_book(this.$refs['excel_table'],opt);
                /* get binary string as output */
                let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
                let now = new Date().Format('yyyy-MM-dd');
                try {
                    const header = this.preset.app.name +'-'+name;
                    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `${header}报表-${now}.xlsx`)
                } catch (e) {
                    console.log(e, wbout)
                }
                return wbout
            },
            handleUploadSuccess(res) {
                this.connectSSE("Admin.Meeting.MakeImport",{uid:res.data.uid});
            },
            handleSSEData(data) {
                this.result.push(data);
                this.$nextTick(()=>{
                    this.$refs['live_view'].scrollTop = this.$refs['live_view'].scrollHeight;
                })
            }
        },
    }
</script>

<style  lang="scss">

    .batch-create-meeting {
        .el-card__body {
            height: calc(100% - 75px);
        }

        .text-message {
            color:#333;

            &.red {
                color:red;
            }
        }

        table {
            td {
                border: 1px solid #eee;
                padding: 5px;
            }
        }
    }


</style>
